import { QuestionMarkCircledIcon } from "@radix-ui/react-icons";
import Tooltip from "@material-ui/core/Tooltip";
import { Typography, makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  tooltip: {
    backgroundColor: "#0C172C",
    color: "#FFFFFF",
    fontFamily: '"Inter", sans-serif',
    fontSize: 14,
    fontWeight: 700,
    lineHeight: "20px",
    maxWidth: 300,
    padding: "8px 16px",
    borderRadius: 4,
  },
  arrow: {
    color: "#0C172C",
  },
}));

const LinesHint = () => {
  const lineWidth = "80px";
  const classes = useStyles();

  return (
    <div className="mt-4 flex flex-col gap-2 text-[16px]">
      <div className="flex items-center justify-between gap-2 w-full">
        <div className="flex items-center gap-1 shrink-0">
          <Typography variant="body2" color="textSecondary">
            Cut line
          </Typography>
          <Tooltip
            title={
              <div>
                Cut line is the guideline that indicates where the printed piece will be trimmed to its final size.
              </div>
            }
            placement="bottom"
            arrow
            classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
          >
            <span>
              <QuestionMarkCircledIcon className="cursor-pointer" />
            </span>
          </Tooltip>
        </div>
        <div className="h-0.5 shrink-0 border-t border-dashed border-red-500" style={{ width: lineWidth }} />
      </div>
      <div className="flex items-center justify-between gap-2 w-full">
        <div className="flex items-center gap-1 shrink-0">
          <Typography variant="body2" color="textSecondary">
            Safety line
          </Typography>
          <Tooltip
            title={
              <div>
                Safety line is a boundary inside the trim line ensuring that important elements like text or logos
                remain safely within the visible area after trimming.
              </div>
            }
            placement="bottom"
            arrow
            classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
          >
            <span>
              <QuestionMarkCircledIcon className="cursor-pointer" />
            </span>
          </Tooltip>
        </div>
        <div className="h-0.5 shrink-0 border-t border-dashed border-green-500" style={{ width: lineWidth }} />
      </div>
    </div>
  );
};

export default LinesHint;
